import React, { Component } from "react";
import Image from "../../Image";
export default class TncIcici extends Component {
  render() {
    return (
      <div>
        <h5 style={{ textAlign: "center", margin: "20px" }}>
          POP AGENT Agreement
        </h5>
        <div className="icici_page">
          This POP Agent Agreement "Agreement" made at Mumbai on the
          _________________ Between Name of the
          agent________________________________, (hereinafter referred to as the
          'POP Agent’ (which expression shall unless repugnant to the context
          mean and include his/ their/its successors-in-interest,
          representatives, nominees, executors, administrators and permitted
          assigns) through its Director/Partner/Proprietor of the One Part; And
          ICICI Prudential Pension Funds Management Company Limited, a company
          incorporated under the provisions of Companies Act, 1956 having its
          Registered Office at ICICI Prulife Towers, 1089 Appa saheb Marathe
          Marg, Prabhadevi, Mumbai 400025 (hereinafter referred to as ”ICICI
          Prudential/Company” which expression shall, unless repugnant or
          contrary to the context, include its successors and assigns) of the
          Other Part:
          <p>
            (The POP Agent and ICICI Prudential are hereinafter collectively
            referred to as "Parties" and individually also as "Party").
          </p>
          <p>WHEREAS:</p>
          <p>
            a. ICICI Prudential is registered with the Pension Fund Regulatory
            and Development Authority under the Pension Fund Regulatory &
            Development Authority Act, 2013 as a pension fund manager, and
            accordingly is engaged in the business of national pension scheme.
          </p>
          <p>
            b. ICICI Prudential is desirous of engaging the services of the POP
            Agent to provide support services.
          </p>
          <p>
            c. The POP Agent has represented to ICICI Prudential that it has the
            requisite expertise and experiences to provide the services in terms
            of this Agreement.
          </p>
          <p>
            d. Relying on the above representation POP Agent, ICICI Prudential
            has agreed to accept the offer of the POP Agent and to appoint the
            POP Agent for providing the services as more particularly described
            in this Agreement on the terms and conditions contained hereinafter.
          </p>
          <p>
            e. The Parties hereto wish to record the terms of their
            understanding in writing.
          </p>
          <p>
            NOW, THEREFORE, THIS AGREEMENT WITNESSETH AND IT IS HEREBY AGREED BY
            AND BETWEEN THE PARTIES AS FOLLOWS:
          </p>
          <h5>1. DEFINITION</h5>
          <p>
            “POP agent” means an individual appointed by ICICI Prudential for
            the purpose of soliciting or procuring NPS business including
            business relating to the opening and continuance of PRAN
          </p>
          <p>
            “Applicable Laws” means Applicable Laws including but not limited to
            the provisions of the Pension Fund Regulatory & Development
            Authority Act, 2013, PFRDA (Pension Fund) Regulations, 2015,
            Anti-Bribery & Corruption Laws and effectively implement all the
            provisions of Sexual Harassment of Women at Workplace ( Prevention,
            Prohibition and Redressal ) Act of 2013 and any regulations, rules,
            guidelines issued by Pension Fund Regulatory & Development Authority
            (“PFRDA”), Reserve Bank of India (“RBI”), Securities and Exchange
            Board of India (“SEBI”), Telecom Regulatory Authority of India
            (“TRAI”), and all labour law enactments or any other statutory,
            regulatory, legislative or governmental or any other similar
            authority. The POP agent shall comply with all Applicable Laws,
            rules, regulations in force from time to time including but not
            limited to provisions of wages, working hours, conditions of service
            and employment and ensure prevention of all prohibitive labour
            practices including but not limited to child labour, forced labour
            or discrimination or bias of any kind.
          </p>
          <p>
            “Documents” means the letters, policies, documents, mails, reports
            and any other written document, by whatever name called.
          </p>
          <h5>2. SCOPE OF SERVICE</h5>
          <p>
            The POP Agent agrees, undertakes and confirms to provide the
            services as defined by the ICICI Prudential and do all acts and
            deeds as described hereunder.
          </p>
          <p>Scope of work – ICICI Prudential</p>
          <p>
            a. ICICI Prudential will provide a platform to the Agent for
            subscriber’s registration.
          </p>
          <p>
            b. ICICI Prudential will facilitate generating PRAN and processing
            contribution within the defined regulatory TAT as communicated from
            time to time
          </p>
          <p>
            c. ICICI Prudential will be responsible to service the customers
            ICICI Prudential will provide reports to the Agents on the number of
            registrations done on monthly basis along with the amount of
            contribution processed.
          </p>
          <p>Scope of work – POP Agent</p>
          <p>
            a) Agent will use only the URL provided to register new subscribers
          </p>
          <p>
            b) Agent is prohibited to collect any fee from the subscriber during
            registration or in the course of servicing the subscriber
          </p>
          <p>
            c) Agent shall not associate with any other POP during their
            association with ICICI Prudential PFM as per the Applicable Law
          </p>
          <h5>3 TERM</h5>
          <p>
            This Agreement shall come into force on ____________________
            (“Effective Date”) and shall be in force from the date of signing
            and shall be in force unless the ICICI Prudential POP Agent
            terminates the Agreement by giving a prior written notice of one (1)
            months to the POP agent. ICICI Prudential further reserves the right
            to terminate this agreement in accordance with clause 13 which deals
            with Termination.
          </p>
          <h5>4. COMMISSION AND REWARD</h5>
          <p>
            Commission for the due performance of obligations in accordance with
            these terms shall be paid to the agent
          </p>
          <p>
            ICICI Prudential shall be entitled to deduct applicable Indirect
            Taxes and Cesses, if any, from the commissions or any other amounts
            payable to the NPS agent. However, in best commercial interests,
            ICICI Prudential may decide to recover only a part of such taxes and
            bear the rest.
          </p>
          <p>
            For Advisor Registered under GST- The Advisor shall duly register
            and comply with all the provisions of the Goods and Services tax
            Laws as applicable to the Advisor and provide all such information
            to ICICI Prudential in this regard. It shall also submit the tax
            invoice within 30 days.
          </p>
          <p>
            The Advisor shall also comply will all procedural formalities
            prescribed by the applicable statutes for raising the invoice
            (Including but not limited to uploading of the data as regards
            invoices / any other documents evidencing the payments to the
            Advisor, in a correct form and in line with the prescribed law and
            rules thereunder). Failure by the Advisor to comply with the
            procedural requirement may cause losses to ICICI Prudential
            including adversely impacting the availment of credit for applicable
            Indirect Taxes, if any, by ICICI Prudential and levy of interest and
            penalty on ICICI Prudential. The Advisor agrees to indemnify ICICI
            Prudential against all losses and damages caused to ICICI Prudential
            due to failure of the Advisor to adhere with or follow the statutory
            requirements for raising invoices. The amount of indemnity shall
            include but may not be limited to the actual loss incurred by ICICI
            Prudential, if tax credit is either deferred or denied as the case
            may be, due to the act of the Advisor and shall also include the
            applicable interest and penalties that could accrue as a result of
            above.
          </p>
          <p>
            In case of any excess or wrong payment of commission or any amount
            to the NPS agent or any commission or any amount which subsequent to
            their payment becomes recoverable or receivable from the NPS agent
            for any reason whatsoever, ICICI Prudential shall be entitled to
            adjust such amounts (which have been paid in excess or wrongly or
            have to be received/recovered back) in the subsequent payment(s) to
            the NPS agent. Alternatively, or where no amounts are due to the NPS
            agent, ICICI Prudential will require the NPS agent to repay or
            refund forthwith such amounts and thereafter the NPS agent shall
            repay the amount within 15 days after the receipt of any
            communication from ICICI Prudential in that regard.
          </p>
          <p>
            {" "}
            payment of commission to the NPS agent after termination/ cessation
            of the relationship between the NPS agent, to the legal heirs of
            such deceased NPS agent shall be as per the Applicable Law, Board
            approved policy and such other communication or guidelines issued by
            ICICI Prudential in this behalf.
          </p>
          <p>
            Notwithstanding the above, ICICI Prudential shall not be obliged to
            pay any commission to the NPS agent if the termination of the
            relationship between ICICI Prudential and the NPS agent is on
            account of fraud or any criminal conduct or violation of Applicable
            Law. In the event the NPS agent intends to reinstate his arrangement
            post termination, no renewal commission would be paid for PRAN
            sourced in the earlier association with ICICI Prudential unless
            specifically permitted in Applicable Law, Board approved policy or
            such other communication or guidelines issued by ICICI Prudential in
            this behalf. Subject to the terms and conditions of this Agreement,
            ICICI Prudential agrees to pay, reimburse and compensate the POP
            Agent the amounts as provided in Schedule B written hereunder.
          </p>
          <p>
            All payments under this Agreement, will be subject to tax deduction
            at source (TDS) as per prevailing Indian Income Tax laws. ICICI
            Prudential will provide the TDS certificate within prescribed
            timelines as per law unless there are any technical issues in
            generating the certificate in the said timelines. If the PAN Card
            copy is not received by ICICI Prudential, no set off or refund or
            rectification of TDS will be done even after submission of valid PAN
            card copy by POP Agent.
          </p>
          <p>
            The rates mentioned in this Agreement are exclusive of applicable
            indirect taxes and cesses, if any.
          </p>
          <p>
            The POP Agent shall duly register and comply with all the provisions
            of the Goods and Service tax Laws as applicable to POP Agent and
            provide all such information to ICICI Prudential in this regard POP
            Agent shall also submit the tax invoice immediately on or before the
            due date of payment not later than six months of invoice date. In
            the event where tax invoice is presented for payment after six
            months of the invoice date, ICICI Prudential will not pay the
            Indirect taxes and cesses, if any charged by the POP Agent in the
            invoice.
          </p>
          <p>
            The POP Agent shall also comply will all procedural formalities
            prescribed by the applicable statutes for raising the invoice
            (Including but not limited to uploading of the data as regards
            invoices / any other documents evidencing the payments to the
            vendor, in a correct form and in line with the prescribed law and
            rules thereunder). Failure by the POP Agent to comply with the
            procedural requirement may cause losses to ICICI Prudential
            including adversely impacting the availment of credit for applicable
            indirect taxes & cesses, if any by ICICI Prudential and levy of
            interest and penalty on ICICI Prudential. The POP Agent agrees to
            indemnify ICICI Prudential against all losses and damages caused to
            ICICI Prudential due to failure of POP Agent to adhere with or
            follow the statutory requirements. The amount of indemnity shall
            include but may not be limited to the actual loss incurred by ICICI
            Prudential, if tax credit is either deferred or denied as the case
            may be, due to the act of the POP Agent and shall also include the
            applicable interest and penalties that could accrue as a result of
            above.
          </p>
          <h5>5. REPRESENTATIONS AND WARRANTIES BY THE POP AGENTPOP AGENT</h5>
          <p>The POP Agent hereby undertakes, affirms and agrees that:</p>
          <p>
            (a) it is in good standing and that it has full authority to enter
            into this Agreement and subject to obtaining the necessary approvals
            under the Applicable Law, to perform its obligations hereunder
            according to the terms hereof.
          </p>
          <p>
            (b) it shall take adequate precautions not to breach the privacy of
            customers of ICICI Prudential during the course of performance of
            its obligations herein. it has full power and authority to enter
            into this Agreement and to take any action and execute any documents
            required by the terms hereof; and that this Agreement, entered into
            has been duly authorised by all necessary authorisation proceedings,
            has been duly and validly executed and delivered, and is a legal,
            valid, and binding obligation of, enforceable in accordance with the
            terms hereof; and that the executants of this Agreement are duly
            empowered and authorised to execute this Agreement and to perform
            all its obligations in accordance with the terms herein.
          </p>
          <p>
            {" "}
            (d) It shall provide such suitably qualified, experienced and
            competent personnel and sub-contractors as may reasonably be
            required for the performance of the services.
          </p>
          <p>
            (e) shall withdraw or bar any of its employee/s or agent/s from the
            provision of the services if, in the sole opinion of ICICI
            Prudential:
          </p>
          <p>
            (I) the quality of service rendered by the said employee/agent is
            not in accordance with the quality specifications stipulated by
            ICICI Prudential; or
          </p>
          <p>
            (ii) it is not in the interest of ICICI Prudential that such
            employee/agent of the Service Provider continues to be involved in
            the provision of services;
          </p>
          <p>
            (f) subject to the terms of this Agreement, shall be responsible for
            the selection, hiring, assigning and supervising of the personnel
            and shall employ sufficient number of personnel to provide the
            services in a prompt and efficient manner. The Service Provider
            shall have a code of conduct for its employees/representatives,
            agents, consultants or any other personnel, with a provision of
            punitive action in case of any fraud, breach, misconduct or
            misappropriation or any other illegal or unethical activity by its
            employees/representatives agents, consultants or any other
            personnel. The Service Provider takes responsibility for any such
            acts and omissions of its personnel and agrees to indemnify and hold
            ICICI Prudential harmless against the same.
          </p>
          <p>
            (g) The Service Provider agrees that the personnel shall work under
            the supervision, control and direction of the Service Provider. The
            Service Provider shall be responsible for all negotiations with
            personnel relating to salaries and benefits, and shall be
            responsible for assessments and monitoring of performance and for
            all disciplinary matters;
          </p>
          <p>
            (h) shall not knowingly engage any person with a criminal
            record/conviction and shall bar any such person from participating
            directly or indirectly in the provision of services under this
            Agreement;
          </p>
          <p>
            (c) shall at all times use all reasonable efforts to maintain
            discipline and good order; amongst its personnel;
          </p>
          <p>
            (d) shall regularly provide updates to ICICI Prudential with respect
            to the provision of the services and shall meet with the personnel
            designated by ICICI Prudential to discuss and review its performance
            at such intervals as may be agreed between the Parties provided that
            in any case this interval shall not be greater than one (1) year;
            and
          </p>
          <p>
            (e) it shall not violate any proprietary and intellectual property
            rights of any third party, including without limitation,
            confidential relationships, patent, trade secrets, copyright and any
            other proprietary rights. The employees of the Service Provider
            shall continue to be the employees of the Service Provider and work
            under its directions and shall not become or claim any employment
            from ICICI Prudential by virtue of providing the services,
            irrespective of the location of their work.
          </p>
          <p>
            (m) No officer of ICICI Prudential, director, employee or immediate
            family member thereof has received or will receive anything of value
            of any kind from the Service Provider or its officers, directors,
            employees or agents in connection with this Agreement; and that none
            of them has a business relationship of any kind with the Service
            Provider, it's personnel or any of its other officers.
          </p>
          <p>
            (f)The POP agent affirms and agrees to procure from its
            employees/agents/authorised representatives/personnel as ICICI
            Prudential may require, an undertaking not to disclose to any third
            party any confidential information or knowledge concerning the
            business of ICICI Prudential and take such steps at the POP agent’s
            own expense as ICICI Prudential may direct in order to enforce or
            restrain any breach of the terms of any such undertaking.
          </p>
          <p>
            (g) The POP agent hereby undertakes to indemnify, compensate and
            reimburse ICICI Prudential against loss, damage, costs, charges and
            expenses, as ICICI Prudential may incur due to delay, non
            performance, malperformance, misperformance, non delivery of the
            documents to the extent of the value of the Document including
            interest, costs, charges, damages etc. which ICICI Prudential may
            suffer or be exposed to. The value of such Documents shall be as
            determined by ICICI Prudential.
          </p>
          <p>(h) The POP agent shall comply with all Applicable Laws;</p>
          <p>
            (i) POP Agent shall implement administrative, physical and technical
            safeguards to protect personal information that are no less rigorous
            than accepted industry practices. POP agent represents and warrants
            that its collection, access, use, storage, disposal and disclosure
            of personal information does and will comply with all applicable
            privacy and data protection laws, as well as all other applicable
            regulations and directives.
          </p>
          <p>
            (j) At a minimum, the POP agent will implement safeguards for the
            protection of personal information which shall include: (i) limiting
            access of personal information to authorized employees; (ii)
            securing business facilities, data centers, paper files, servers,
            back-up systems and computing equipment, including, but not limited
            to, all the devices and other equipment with information storage
            capability; (iii) implementing network, device, software
            application, database and platform security; (iv) securing
            information transmission, storage and disposal; (v) implementing
            authentication and access controls within media, software
            applications, operating systems and equipment; (vi) implement
            malware protection and prevention controls; (vii) encrypting
            highly-sensitive personal information while in storage media and
            transmitted over public or wireless networks; (viii) segregate
            personal information from information of the POP agent or its other
            customers so that personal information is segregated from any other
            types of information; (ix) implementing appropriate personnel
            security and integrity procedures and practices, including, but not
            limited to, conducting background checks consistent with Applicable
            Law; and (x) providing appropriate privacy and information security
            training to the POP agent’s employees.
          </p>
          <p>
            (k) Reporting of improper use, disclosure of data or security breach
            – The POP agent shall report within 24 hours of knowledge about any
            breach of information involving data/information provided
            by/pertaining to ICICI Prudential or any cyber security incident
            involving the systems/devices used for activities of ICICI
            Prudential covered under this Agreement.
          </p>
          <p>
            (l) In performing its duties under this Agreement, the POP agent
            will comply with all applicable anti-bribery and anti-corruption
            laws (and related regulation and guidance). In particular, the POP
            agent hereby acknowledges and agrees: i. it shall not act in such a
            way that is or could be construed as a violation of these laws and
            requirements, including but not limited to offering a bribe or
            making a facilitation payment to a public official or to any other
            party; ii. that it will ensure that its activities in connection or
            relating to its obligations under the Agreement will not cause ICICI
            Prudential to be in breach of any anti-bribery and anti-corruption
            laws (and related regulation and guidance); iii. that it will ensure
            that it has appropriate internal procedures within its organisation
            to prevent bribery by its workforce and other people under its
            control; and iv. if POP agent, in connection with or relating to its
            obligations under the Agreement, is asked to partake in any
            activity, that is in violation of any anti-bribery or
            anti-corruption laws, or becomes aware of any such conduct by its
            workforce or within its control and concerning or relating to the
            Agreement, POP agent agrees to immediately report the details of
            this to ICICI Prudential. ICICI Prudential shall have the right to
            terminate this Agreement on no notice, without liability, for any
            breach of this clause by the POP agent.
          </p>
          <p>(m) POP agent confirms that:</p>
          <p>
            i. They have not been found to be of unsound mind by a court of
            competent jurisdiction;
          </p>
          <p>
            ii. They have not been found guilty or knowingly participated in or
            connived in commission or abetment or attempt to commit any offence
            under any law for the time being in force including but not limited
            to criminal misappropriation, criminal breach of trust, cheating or
            forgery;
          </p>
          <p>
            iii. No criminal prosecution is pending or commenced or resulting in
            conviction against them.
          </p>
          <p>
            iii. They will not be an agent for any other PFM company while my
            arrangement with ICICI Prudential
          </p>
          <p>
            iv. They have noted, adhered and would continue to adhere the
            instruction issued by the Company from time to time.
          </p>
          <p>
            v. They have noted, adhered and would continue to adhere to the Code
            of conduct as mentioned in (SCHEDULE A)
          </p>
          <h5>6. CONFIDENTIALITY</h5>
          <p>
            (a) The Parties will, at all times, maintain the utmost
            confidentiality regarding the contents of this Agreement and any
            business, technical or financial information that is, at the time of
            disclosure, whether designated in writing or not as confidential
            (hereinafter the “Confidential Information”). None of the Parties
            will make any announcement to the public or to any third Party
            regarding the arrangements contemplated by this Agreement without
            the consent of the other Party, provided such consent shall not be
            unreasonably withheld or delayed. Any statement or disclosure which
            may be required by law or called for, by the requirements of any
            regulatory authority and any such statement or disclosures shall be
            no more extensive than is usual or necessary to meet the
            requirements imposed upon the Party making such statement on
            disclosure.{" "}
          </p>
          <p>
            (b)The receiving Party shall not be liable for disclosure or use of
            any Confidential Information if the same is:
          </p>
          <p>
            (i) in the public domain through no fault of the receiving party,
          </p>
          <p>
            (ii) rightfully received from a third party without any obligation
            of confidentiality,
          </p>
          <p>
            (iii) rightfully known to the receiving party without any limitation
            on use or disclosure prior to its receipt from the disclosing party,
          </p>
          <p>(iv) independently developed by the receiving party,</p>
          <p>
            (v) generally made available to third parties without any
            restriction on disclosure, or
          </p>
          <p>
            (vi) communicated in response to a valid order by a court or other
            governmental body, as otherwise required by law, or as necessary to
            establish the rights of either party under this Agreement
          </p>
          <p>
            (c ) The POP agent affirms not to make or retain any copies or
            record of any Confidential Information submitted by ICICI Prudential
            other than as may be required for the performance of the POP Agent
            ’s obligation under this Agreement. The POP Agent shall notify ICICI
            Prudential immediately of any unauthorised or improper use or
            disclosure of the Confidential Information. The POP Agent shall
            return all the Confidential Information, which is in the custody of
            the POP Agent at the end of the specific assignment.
          </p>
          <p>
            (d) The POP Agent affirms to keep the data or information including
            but not limited to policyholder’s information confidential and
            secure during and post the expiry/termination of the Agreement.
          </p>
          <p>
            (e) The POP Agent agrees to not use any such information for the
            benefit of POP Agent or its employees/representatives and shall
            ensure that they do not disclose or use such information for any
            personal benefit.
          </p>
          <p>
            (f) The provisions of this Clause shall survive the termination of
            this Agreement.
          </p>
          <h5>7. INDEMNITY</h5>
          <p>
            The POP Agent shall, indemnify, defend and hold harmless ICICI
            Prudential and its officers, directors, employees, representatives,
            agents respective directors, and assigns from and against any
            liability or any other loss that may occur, arising from or relating
            to:
          </p>
          <p>
            (a) a breach, non-performance or inadequate performance by the POP
            Agent of any of the terms, conditions, covenants, representations,
            undertakings, obligations or warranties under this Agreement;
          </p>
          <p>
            (b) the acts, errors, representations, misrepresentations, willful
            misconduct or negligence of the POP Agent, its employees,
            subcontractors and agents in performance of its obligations under
            this Agreement; or
          </p>
          <p>(c ) Any breach of third party intellectual property rights.</p>
          <p>(d) any deficiency in the services of the POP Agent.</p>
          <p>
            (e ) The provisions of this Clause shall survive the termination of
            this Agreement.
          </p>
          <h5>8 INSPECTION AND RIGHT TO AUDIT</h5>
          <p>
            POP Agent shall keep and maintain complete and accurate books
            statements and records of all the operations and expenses in
            connection with the activities mentioned herein POP Agent shall, at
            all reasonable times, allow ICICI Prudential, its management,
            auditors, chartered accountant firms, regulators and all other
            persons authorised by the ICICI Prudential to inspect, examine,
            audit and take copies of the service provider’s books, statements
            and other records which are directly relevant to or connected with
            this Agreement and / or the service provider’s obligations,
            including its security measures. The Service Provider will
            co-operate with such persons to ensure a prompt and accurate
            verification and audit. Such audits or reviews will be at the
            expense of ICICI Prudential. However, if the audit discovers
            discrepancies or overcharges, then, upon completion of such audit or
            review, the service provider will reimburse ICICI Prudential for
            discrepancies or overcharges and for such additional cost of the
            audit.
          </p>
          <p>
            The Service Provider shall allow PFRDA or persons authorized by
            PFRDA to access the Service Provider's documents, records of
            transaction, and other necessary information given to, stored or
            processed by the Service Provider in connection to this agreement or
            services rendered under it within a reasonable time. PFRDA reserves
            the right to access the operations of the Service Provider to the
            extent such documents, records of transaction, and other necessary
            information which are relevant to ICICI Prudential.
          </p>
          <p>
            Notwithstanding anything contained in the Agreement, the Service
            Provider shall not prevent nor impede ICICI Prudential from meeting
            any of its respective regulatory obligations, nor the PFRDA from
            exercising its regulatory powers of conducting inspection,
            investigation, obtaining information from either ICICI Prudential or
            the Service Provider.
          </p>
          <p>
            None of the members/officers/trustees of PFRDA OR NPS Trust, shall
            be liable to the Service Provider in relation to any conduct or
            action on the part of ICICI Prudential affecting the rights interse
            ICICI Prudential and the Service Provider. Service Provider warrants
            that authorized representatives of the PFRDA shall at all times have
            the absolute right to: -
          </p>
          <p>
            a) examine the books, records, information, systems and the internal
            control environment in the Service Provider (or sub-contractor as
            applicable), to the extent that they relate to the service being
            performed for ICICI Prudential and
          </p>
          <p>
            b) Access any internal audit reports or external audit findings of
            the Service Provider that concern the service being performed for
            ICICI Prudential.
          </p>
          <h5>9. CORPORATE AUTHORITY</h5>
          <p>
            The Parties represent that they have taken all necessary corporate
            action to authorize the execution and consummation of this Agreement
            and will furnish satisfactory evidence of same upon request.
          </p>
          <h5>10.LAW AND ARBITRATION</h5>
          <p>
            (a) The provisions of this Agreement shall be governed by and
            construed in accordance with Indian law.
          </p>
          <p>
            (i)Any dispute, controversy or claims arising out of or relating to
            this Agreement or the breach, termination or invalidity thereof,
            shall be settled by arbitration in accordance with the provisions of
            the Arbitration and Conciliation Act, 1996.
          </p>
          <p>
            (ii) The arbitral tribunal shall be composed of a sole arbitrator to
            be appointed by both the parties with mutual understanding.
          </p>
          <p>
            (iii)The venue and seat of arbitration shall be Mumbai and any award
            whether interim or final, shall be made, and shall be deemed for all
            purposes between the parties to be made, in Mumbai.
          </p>
          <p>
            (iv)The arbitral procedure shall be conducted in the English
            language and any award or awards shall be rendered in English. The
            procedural law of the arbitration shall be Indian law.
          </p>
          <p>
            (v) The award of the arbitrator shall be final and conclusive and
            binding upon the Parties, and the Parties shall be entitled (but not
            obliged) to enter judgement thereon in any one or more of the
            highest courts having jurisdiction. The Parties further agree (to
            the maximum extent possible and allowed to them) that such
            enforcement shall be subject to the provisions of the Arbitration
            and Conciliation Act, 1996 and neither Party shall seek to resist
            the enforcement of any award in India on the basis that award is not
            subject to such provisions.
          </p>
          <p>
            (vi) The rights and obligations of the Parties under, or pursuant
            to, this Clause, including the arbitration agreement in this Clause,
            shall be under the exclusive jurisdiction of the courts located at
            Mumbai.
          </p>
          <h5>9. PUBLICITY</h5>
          <p>
            The POP Agent shall not use the name and/or trademark/logo of ICICI
            Prudential, its group companies, subsidiaries or associates in any
            sales or marketing publication or advertisement, or in any other
            manner without prior consent of ICICI Prudential. In case of any
            misuse of the name and/or trademark/logo of ICICI Prudential, its
            group companies, subsidiaries or associates, ICICI Prudential may
            take any action as may be deemed fit against the POP Agent including
            but not limited to any equitable or injunctive relief.
          </p>
          <h5>10. PROPRIETORY RIGHTS:</h5>
          <p>
            The POP Agent agrees that any product including but not limited to
            all information, reports, studies, information technology including
            but not limited to hardware, software (including source codes,
            object codes and executables), flow charts, diagrams and other
            tangible and intangible material of any nature whatsoever produced
            by or as a result of any of the services rendered hereunder shall be
            the sole and exclusive property of ICICI Prudential. In furtherance
            thereof, the POP Agent hereby irrevocably grants, assigns, transfers
            to ICICI Prudential all rights, title and interest of any kind, in
            and to any such product produced hereunder. The POP Agent shall not
            be entitled to make any use of any of the said materials except as
            may be expressly permitted by ICICI Prudential.
          </p>
          <h5>11. POP AGENT</h5>
          <p>
            This Agreement is on a principal to agent basis between the Parties
            hereto. Nothing contained in this Agreement shall be construed or
            deemed to create any association, partnership or joint venture or
            employer-employee relationship in any manner whatsoever between the
            parties. The POP Agent acknowledges that it’s rendering of services
            subject to the terms and conditions agreed upon in this contract and
            agrees not to hold itself out to be an employee or servant of ICICI
            Prudential or any subsidiary or affiliate thereof.
          </p>
          <h5>12. SUB-CONTRACTORS</h5>
          <p>
            The POP AgentPOP agent shall not assign or subcontract any of its
            responsibilities contained in this Agreement to any agent, sub-agent
            or subcontractor without prior permission of ICICI Prudential.
          </p>
          <p>
            Nothing in this Agreement shall be construed as creating any
            contractual or other relationship between ICICI Prudential and any
            such contractor/ sub-contractor or agent, nor any obligation on the
            part of ICICI Prudential to pay or see to the payment of any money
            due to any contractor/ sub-contractor/agent.
          </p>
          <h5>13. TERMINATION</h5>
          <p>
            (a) Notwithstanding anything herein contained, ICICI Prudential
            shall by giving thirty (30) days’ notice in writing, terminate this
            Agreement under any one or more of the following conditions :
          </p>
          <p>
            i) In the event of default of performance of any of the services as
            specified under Schedule A written hereunder or the POP Agent herein
            is in contravention of any law, as may be applicable from time to
            time, or industry practice, or under the circumstances which would
            amount to objectionable service;
          </p>
          <p>
            ii) If either Party fails to perform and observe any of their
            obligations under this Agreement;
          </p>
          <p>
            iii) If a petition for insolvency is filed against any Party and
            such petition is not dismissed within ninety (90) days after filing
            and/or if any Party makes an arrangement for the benefit of its
            creditors or, if the court receiver is appointed as receiver of
            all/any of any Party's properties.
          </p>
          <p>
            (b) Notwithstanding anything to the contrary in the Agreement or to
            anything mentioned in Clause 15(a) above, ICICI Prudential reserves
            the right to terminate this agreement by giving a seven (7) days
            written notice to the POP Agent.
          </p>
          a)
          <p>
            c) POP Agent shall bill ICICI Prudential up to the last day of
            service and shall refund any prepaid fees or unused amounts in case
            of such termination. It is hereby agreed and understood by the POP
            Agent that the provisions of this Clause shall not limit or restrict
            nor shall they preclude ICICI Prudential from pursuing such further
            and other legal actions, against the POP Agent for any breach or
            non-compliance of the terms of this Agreement.
          </p>
          <p>
            (d) In the event of proven fraud or forgery or any other misconduct,
            ICICI Prudential has the right to terminate the agreement without
            giving any notice to the Agency.{" "}
          </p>
          <p>
            (e) In the event that this Agreement is terminated for any reasons,
            the POP Agent shall forthwith hand over to ICICI Prudential the
            possession of all documents, material and any other property
            belonging to the ICICI Prudential including but not limited to
            customer data that may be in the possession of the POP Agent or any
            of its employees, agents, subcontractors, sub-agents or individuals
            assigned to perform the services under this Agreement.
          </p>
          <h5>FORCE MAJEURE</h5>
          <p>
            Parties shall not be liable for any failure or delay in performance
            under this agreement resulting directly or indirectly from causes
            beyond its reasonable control due to act of God, war declared, civil
            or political disturbance, drought, floods, fire, theft, accidents
            and other exceptional circumstances. In such a situation, both
            party’s liability ceases under this Agreement and then both the
            parties shall discuss the course of action to be taken afterwards.
          </p>
          <h5>BUSINESS CONTINUITY MANAGEMENT</h5>
          <p>
            The POP Agent shall have an established a Business continuity /
            Disaster recovery framework that addresses the preparations which
            are necessary to identify the impact of potential losses arising
            from an emergency or a disaster, the data and functional recovery
            strategy, back-up sites and alternate communication networks and to
            administer a comprehensive testing and maintenance program. The
            Service Provider shall comply with continuity requirements, aligning
            with approved SLA as informed by ICICI Prudential from time to time.
          </p>
          <h5>18. Purging policy:</h5>
          <p>
            Service Provider to follow the purging policy as per the given
            timeline in the agreement.{" "}
          </p>
          <h5>Return of Personal Information</h5>
          <p>
            At any time during the term of this Agreement at the written request
            of ICICI Prudential or upon the termination or expiration of this
            Agreement for any reason, POP Agent shall, and shall instruct all
            authorized persons to promptly return to ICICI Prudential all
            copies, whether in written, electronic or other form or media, of
            personal information in its possession or the possession of such
            authorized persons, or securely dispose of all such copies, and
            certify in writing to ICICI Prudential that such personal
            information has been returned to or disposed of securely. POP Agent
            shall comply with all reasonable directions provided by ICICI
            Prudential with respect to the return of personal information. POP
            Agent shall notify ICICI Prudential of all personal information that
            is no longer in use or required by the Service Provider and obtain
            from ICICI Prudential written approval to delete and purge it from
            all online systems, including backup and recovery systems and all
            archival storage media.
          </p>
          <p>
            The POP Agent shall not retain the data provided under this
            Agreement (hereinafter referred to as “Data”) including but not
            limited to voice recordings pertaining to performance of the
            Services beyond [3] days. The Service Provider shall provide copy of
            the data to the ICICI Prudential within 7 days of expiry of the cut
            off period, starting from the Effective Date of this Agreement.
            ICICI Prudential shall communicate in writing any errors in the
            submitted Data within 7 days from receipt of the same, failing which
            it shall be deemed that the submitted Data is received correctly. If
            ICICI Prudential communicates any error in writing within the
            specified time limit then the Service Provider shall provide ICICI
            Prudential with a new Data within a reasonable time period and ICICI
            Prudential shall communicate in writing regarding any
            errors/discrepancy or defects in the same within 7 days from the
            receipt of the data. If ICICI Prudential does not communicate any
            errors in writing within the specified time, the Service Provider
            shall then purge the Data from the storage device as per its then
            prevailing security policies.
          </p>
          <h5>15. MISCELLANEOUS</h5>
          <p>
            (a) Any provision of this Agreement may be amended or waived if, and
            only if such amendment or waiver is in writing and signed, in the
            case of an amendment by each Party, or in the case of a waiver, by
            the Party against whom the waiver is to be effective.
          </p>
          <p>
            (b) No failure or delay by any Party in exercising any right, power
            or privilege hereunder shall operate as a waiver thereof nor shall
            any single or partial exercise of any other right, power or
            privilege. The rights and remedies herein provided shall be
            cumulative and not exclusive of any rights or remedies provided by
            law.
          </p>
          <p>
            (c) The provisions of this Agreement shall be binding upon and inure
            to the benefit of the Parties hereto and their respective successors
            and permitted assigns.
          </p>
          <p>
            (d) Unless otherwise provided herein, all notices or other
            communications under or in connection with this Agreement shall be
            given in writing and may be sent by personal delivery or post or
            courier or facsimile. Any such notice or other communication will be
            deemed to be effective if sent by personal delivery, when delivered,
            if sent by post, two days after being deposited in the post and if
            sent by courier, one day after being deposited with the courier, and
            if sent by facsimile, when sent (on receipt of a confirmation to the
            correct facsimile number).
          </p>
          <p>
            (e) This Agreement constitutes the entire agreement between the
            Parties with respect to the subject matter hereof and supersedes all
            prior written agreements, understandings and negotiations, both
            written and oral, between the Parties with respect to the subject
            matter of this Agreement. No representation, inducement, promise,
            understanding, condition or warranty not set forth herein has been
            made or relied upon by any Party hereto.
          </p>
          <p>
            (f) Neither this Agreement nor any provision hereof is intended to
            confer upon any Person other than the Parties to this Agreement any
            rights or remedies hereunder.
          </p>
          <p>
            (g) In connection with this Agreement, as well as all transactions
            contemplated by this Agreement, each Party agrees to execute and
            deliver such additional documents and to perform such additional
            actions as may be necessary, appropriate or reasonably requested to
            carry out or evidence the transactions contemplated hereby.
          </p>
          <p>
            (h) The invalidity or unenforceability of any provisions of this
            Agreement in any jurisdiction shall not effect the validity,
            legality or enforceability of the remainder of this Agreement in
            such jurisdiction or the validity, legality or enforceability of
            this Agreement, including any such provision, in any other
            jurisdiction, it being intended that all rights and obligations of
            the Parties hereunder shall be enforceable to the fullest extent
            permitted by law.
          </p>
          <p>
            (i) The captions herein are included for convenience of reference
            only and shall be ignored in the construction or interpretation
            hereof.
          </p>
          <p>
            (j) This Agreement together with all Schedules written hereunder
            form a single Agreement between the Parties hereto.
          </p>
          <p>
            () This Agreement has been signed in duplicate and / or online, each
            of which shall be deemed to be an original.
          </p>
          <p>
            (l) Such of the provisions of this Agreement as are necessary to
            survive for giving effect to them will survive notwithstanding
            termination of this Agreement.
          </p>
          <p>
            (M) POP Agent shall maintain reasonable and appropriate insurance
            coverage in relation to the risks associated with the Services
            .ICICI Prudential shall be entitled, with notice to the POP Agent,
            to assign any of its rights and obligations under this Agreement to
            any third party.
          </p>
          <p>
            Change Request: The Service Provider shall not unreasonably refuse
            acceptance of any change to the Services as initiated by ICICI
            Prudential. The Service Provider shall analyze and review any such
            change request initiated (“Change Request”)by ICICI Prudential and
            within a reasonable time inform ICICI Prudential in writing of the
            results of such review as to its feasibility, its impact on the
            agreed project schedule, the agreed delivery and milestone dates
            and/or the agreed fees and prices. If the Parties cannot agree on a
            fixed price for a specific change, the Service Provider shall offer
            and perform such Change Request on a time and expense basis
            according to such rates as would have been charged by independent
            third party for similar work. This Agreement has been executed by
            the Parties hereto on the day and year first above written.
          </p>
          <p>Signed and Delivered by the within ]</p>
          <p>named POP agent ]</p>
          <p>____ by the hands of its Authorised ]</p>
          <p>___________________________________ ]</p>
          <p>Signatory, Mr. __, ]</p>
          <p>Director/Partner/Proprietor</p>
          <p>Signed and Delivered by the within ]</p>
          <p>named ICICI Prudential Pension ]</p>
          <p>Funds Management Company ]</p>
          <p>Limited by the hands of its ]</p>
          <p>Authorised Signatory, ]</p>
          <p>Mr. Rahul Bhagat _________</p>
          <h5 className="icici_headings">SCHEDULE A</h5>
          <h5 className="icici_headings">
            POP AGENT Code of Conduct for Agents
          </h5>
          <p>
            1. The NPS agent shall not and is not authorised to accept any
            money, in cash from any prospect/ customer/ policyholders, where any
            such person wishes or proposes to make any payment in cash. The NPS
            agent shall direct him to the appropriate office of ICICI Prudential
            for making such payment personally or advise him of the permissible
            modes of payment to ICICI Prudential. NPS agent can accept cheque,
            demand draft or other payment instruments (not being a bearer
            cheque) from a prospect if and only if they are drawn in the name of
            ICICI Prudential. Without prejudice to the other provisions of the
            Terms providing for indemnification to ICICI Prudential by the NPS
            agent, the NPS agent specifically confirms and undertakes to hold
            ICICI Prudential harmless and indemnified at any time and at all
            times against any demand, claim, action or proceeding arising from
            any breach, whether intended or not, of the provisions of this
            clause. The NPS agent further confirms that where he accepts any
            Cash in breach of the clause, he shall be acting as agent of the
            customer till the time the cash is deposited by him with ICICI
            Prudential, and will continue to be such agent till he continues to
            hold any cash accepted from such customer /policyholder.
          </p>
          <p>
            2. The NPS agent shall attend all meetings, workshops, trainings and
            briefings conducted by or on behalf of ICICI Prudential to
            create/enhance awareness about the Insurance Products, business
            plans and policies of ICICI Prudential and any other matter of
            relevance to them of which reasonable notice has been given to the
            NPS agent. In particular the NPS agent shall attend all training and
            refresher sessions for NPS agents unless prevented by a cause, which
            in the opinion of ICICI Prudential, is reasonable.
          </p>
          <p>
            3. Where the NPS agent intends to bring out or publish any material
            in any form or through any medium, concerning ICICI Prudential its
            business or its Products, the NPS agent shall obtain prior written
            approval of ICICI Prudential. Further the NPS agent shall observe,
            follow and comply with the provisions of the PFRDA Regulations for
            the same.
          </p>
          <p>
            4. The NPS agent shall solicit and procure business for ICICI
            Prudential and discharge his obligations under the Terms in
            accordance with ICICI Prudential’s corporate objectives and with
            particular regard to ICICI Prudential's image and standing in the
            industry and in the community.
          </p>
          <p>
            5. The NPS agent shall observe, follow and comply with all the
            communications, directions and instructions given by ICICI
            Prudential from time to time, either generally or with particular
            reference to the NPS agent. Such communications, directions arid
            instructions may be sent by courier, email, post, fax or may be
            posted on the Restricted Website Area.
          </p>
          <p>
            6. The NPS agent shall familiarize himself with the Applicable Law
            as in force from time to time and which has a bearing on the
            discharge of his obligations as an insurance agent; provided that in
            the event of any change in the Applicable Law resulting in a
            dilution or abrogation of his obligations Under the Terms, to the
            extent not provided otherwise, the NPS agent shall continue to be
            bound by the obligations as were existent prior to such change,
            unless expressly approved in writing by ICICI Prudential, or unless
            inconsistent with Applicable Law.
          </p>
          <p>
            7. The NPS agent shall not solicit or procure NPS business through
            any other registered Point of presence registered with PFRDA
          </p>
          <h5 className="icici_headings">SCHEDULE B</h5>
          <h5 className="icici_headings">Compensation / Commercials</h5>
          <h5 style={{ marginLeft: 20, textDecoration: "under-line" }}>
            Commercials
          </h5>
          <Image
            style={{ width: "100%", height: 200 }}
            src={`/images/table.png`}
            alt=""
          ></Image>
          <h5>Note (Payment Terms):</h5>
          <p>
            1. Basis the monthly business, Agent with GST will raise the invoice
            and fee will be transferred to the Agent. For agents without GST the
            fees will be transferred without invoice
          </p>
          <p>
            2. ICICI Prudential will make payments within 30 working days of
            receipt of the correct bill / invoice along with necessary
            supporting. All the payments will be made by account payee Cheque at
            Mumbai in the name given by the agent during registration or through
            ECS payment to the bank account of vendor.
          </p>
          <p>
            3. Any payments made, if subsequently found to be recoverable by
            ICICI Prudential for any reason whatsoever, shall be adjusted in
            next payment or called for by a demand notice. Failure to pay the
            same within 10 days will attract an interest of 24% per annum after
            10 days from the date of demand notice sent by ICICI Prudential.
          </p>
          <p>
            4. The POP Agent needs to submit the invoice within 30 days from the
            end of the activity. In case of late submission of bills, post the
            mentioned timelines, a penalty shall be levied for late submission
            at 50 % of the invoice value.
          </p>
          <p>
            5. The POP Agent would be responsible to give invoice within 30 days
          </p>
          <p>
            6. ICICI Prudential do not hold any responsibility for payment of
            the invoices which are submitted after completing one financial year
            from the date of occurrence of the activity.
          </p>
        </div>
      </div>
    );
  }
}
